import { type Decorator } from 'final-form';
import { useMemo } from 'react';
import { Form, type FormProps } from 'react-final-form';

import { useHotelChangeRegistration } from './session';

/** Track form edits without changing the caller's rendering or subscriptions. */
export function HotelForm<
  FormValues = Record<string, unknown>,
  InitialFormValues = Partial<FormValues>,
>({ decorators, ...props }: FormProps<FormValues, InitialFormValues>) {
  const registerChanges = useHotelChangeRegistration();
  const changeDecorator = useMemo<Decorator<FormValues, InitialFormValues>>(
    () => (form) => {
      const unsubscribe = form.subscribe(
        // Some legacy handlers return before a request succeeds. Only an
        // explicit reset/reinitialization establishes that edits were saved.
        ({ dirty }) => registerChanges(dirty),
        { dirty: true },
      );
      return () => {
        unsubscribe();
        registerChanges(false);
      };
    },
    [registerChanges],
  );
  const trackedDecorators = useMemo(
    () => [...(decorators ?? []), changeDecorator],
    [decorators, changeDecorator],
  );

  return <Form {...props} decorators={trackedDecorators} />;
}
